import { render } from "./BalLoadingBlock.vue?vue&type=template&id=5628d410&ts=true"
import script from "./BalLoadingBlock.vue?vue&type=script&lang=ts"
export * from "./BalLoadingBlock.vue?vue&type=script&lang=ts"

import "./BalLoadingBlock.vue?vue&type=style&index=0&id=5628d410&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__